import WidgetBox from "components/elements/WidgetBox/widget-box";
import {
  Flex,
  Stack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Thead,
  Tr,
  Checkbox,
  HStack,
} from "@chakra-ui/react";
import draws from "../../mocks/draws.json";
import { useCustomFormats } from "hooks/useCustomFormat";
import React from "react";
import { StatusFilter } from "../status-filter";
import { ExportButton } from "../export-button";
import { ColumnsButton } from "../columns-button";
import { Draw } from "../../types/draw";
import { ThCheckbox } from "./components/th-checkbox";
import { ThSort } from "./components/th-sort";
import { TdStatus } from "./components/td-status";
import { TdActions } from "./components/td-actions";
import { ThActions } from "./components/th-actions";
import { TdCheckbox } from "./components/td-checkbox";

export function DrawsTable() {
  const { formatDate, formatCurrency } = useCustomFormats();
  const [selectedStatus, setSelectedStatus] = React.useState<string>("all");

  const SubTitle = () => (
    <Text fontWeight="normal" color="#6C6B6E" mt={-2}>
      Draw requests for construction loans.
    </Text>
  );

  const TableFiltersAndActions = () => {
    const statuses = [
      { value: "all", label: "All" },
      { value: "Succeeded", label: "Succeeded" },
      { value: "Failed", label: "Failed" },
      { value: "Pending", label: "Pending" },
    ];

    return (
      <Flex justifyContent="space-between" gap={2}>
        <StatusFilter statuses={statuses} value={selectedStatus} onChange={setSelectedStatus} />
        <HStack gap={2}>
          <ColumnsButton />
          <ExportButton />
        </HStack>
      </Flex>
    );
  };

  const TableData = () => {
    const filteredDraws = (draws as Draw[]).filter(
      draw => selectedStatus === "all" || draw.status === selectedStatus
    );

    return (
      <TableContainer>
        <Table>
          <Thead>
            <Tr>
              <ThCheckbox />
              <ThSort>ID</ThSort>
              <ThSort>Created On</ThSort>
              <ThSort>Borrower Company</ThSort>
              <ThSort>Loan Name</ThSort>
              <ThSort>Description</ThSort>
              <ThSort>Amount</ThSort>
              <ThSort>Status</ThSort>
              <ThActions />
            </Tr>
          </Thead>
          <Tbody>
            {filteredDraws.map(draw => (
              <Tr key={draw.id}>
                <TdCheckbox />
                <Td>{draw.id}</Td>
                <Td>{formatDate(draw.createdOn)}</Td>
                <Td>{draw.borrowerCompany}</Td>
                <Td>{draw.loanName}</Td>
                <Td>{draw.description}</Td>
                <Td fontWeight="bold">{formatCurrency(draw.amount)}</Td>
                <TdStatus status={draw.status} failureReason={draw.failureReason} />
                <TdActions />
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    );
  };

  return (
    <WidgetBox title="Draws">
      <Stack gap={6}>
        <SubTitle />
        <TableFiltersAndActions />
        <TableData />
      </Stack>
    </WidgetBox>
  );
}
